<div class="page-wrapper">
    <div class="container login-container">
        <div class="login-page">
            <div class="login-left">
                <h6>{{ 'Our Technology' | translate }}</h6>
                <h1>{{ 'Helping Mines' | translate }}<br />{{ 'Pinpoint Occupational' | translate }}<br />{{ 'Silica Exposure Risks' | translate }}</h1>
                <div class="ripple">
                    <img src="../../../assets/images/ripple-bg.png">
                </div>
            </div>
            <div class="login-right">
                <div class="login-form">
                    <div class="logo-form">
                        <img src="../../../assets/images/new-logo.png">
                    </div>

                    <br />
                    <br />
                    <br />
                    <span class="Log-in-to-your-accou">
                        Please enter your new password.
                    </span>
                    <form class="mt-2" [formGroup]="form" (ngSubmit)="submit()">
                        <label class="field-label" for="reset-new-password">{{ 'Password' | translate }}</label>
                        <div class="form-group">
                            <input id="reset-new-password" type="password" formControlName="newPassword" autocomplete="new-password"
                                [placeholder]="'New Password' | translate" class="form-control" [class.field-invalid]="newPasswordInvalid">
                            <span class="form-control-icon"><img src="assets/images/lock_black.png"></span>
                        </div>
                        <label class="field-label" for="reset-confirm-password">{{ 'Confirm password' | translate }}</label>
                        <div class="form-group">
                            <input id="reset-confirm-password" type="password" formControlName="confirmPassword" autocomplete="new-password"
                                [placeholder]="'Confirm Password' | translate" class="form-control" [class.field-invalid]="confirmPasswordInvalid">
                            <span class="form-control-icon"><img src="assets/images/lock_black.png"></span>
                        </div>
                        <app-password-criteria class="reset-password-criteria" [password]="newPassword"></app-password-criteria>
                        <div class="form-group">
                            <input type="submit" value="Continue" [disabled]="!canSubmit">
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <footer>
            <div class="container ml-2">
                <p><app-copyright></app-copyright></p>
            </div>
        </footer>
    </div>
</div>